import type React from 'react';

import { useChangePassword } from '@/hooks/settings/useChangePassword';
import ChangePasswordView from '@/components/organism/Settings/ChangePassword/ChangePassword.view';

export function ChangePassword(): React.JSX.Element {
  const { state, handlers } = useChangePassword();

  return (
    <ChangePasswordView
      password={state.password}
      confirmPassword={state.confirmPassword}
      showPassword={state.showPassword}
      showConfirmPassword={state.showConfirmPassword}
      passwordError={state.passwordError}
      globalError={state.globalError}
      stage={state.stage}
      phase={state.phase}
      isRunning={state.isRunning}
      isComplete={state.isComplete}
      isAwaitingConfirmation={state.isAwaitingConfirmation}
      isLeaveBlocked={state.isLeaveBlocked}
      isSubmitDisabled={state.isSubmitDisabled}
      regeneratedCount={state.regeneratedCount}
      totalCount={state.totalCount}
      failedCount={state.failedCount}
      onPasswordChange={handlers.onPasswordChange}
      onConfirmPasswordChange={handlers.onConfirmPasswordChange}
      onTogglePassword={handlers.onTogglePassword}
      onToggleConfirmPassword={handlers.onToggleConfirmPassword}
      onSubmit={handlers.onSubmit}
      onConfirmProceed={handlers.onConfirmProceed}
      onCancelConfirmation={handlers.onCancelConfirmation}
      onConfirmLeave={handlers.onConfirmLeave}
      onStayHere={handlers.onStayHere}
    />
  );
}

ChangePassword.displayName = 'ChangePassword';

export default ChangePassword;
